<template lang="html">
  <div>

    <b-modal
      id="modal-5"
      title="Muuta tehtävää"
      @ok="update_task"
    >
        <b-container class="p-0">
          <b-form @submit.prevent="update_task" inline>
            <b-row no-gutters  class="w-100">
              <b-col cols="6">
                <label>Tehtävä</label>
              </b-col>
              <b-col class="w-100">
                <label>Tärkeys</label>
              </b-col>
              <b-col>
                <label>Deadline</label>
              </b-col>
            </b-row>
            <b-row no-gutters  class="w-100">
              <b-col>
                <b-form-input v-model = "selected.title" class="w-100" type="text" :placeholder="selected.title"/>
              </b-col>
              <b-col md="auto">
                <b-form-spinbutton v-model = "selected.priotited" min = "0" max = "5" inline></b-form-spinbutton>
              </b-col>
              <b-col md="auto">
                <b-form-input
                  v-model = "D_day"
                  type="date"
                  />
              </b-col>
            </b-row>
            <b-row  class="w-100 p-3">
              <b-col>
                <label>Lisä info</label>
                <b-form-textarea
                id="textarea"
                class="w-100"
                v-model="selected.info_text"
                placeholder="Lisä info..."
                rows="3"
                max-rows="6"
              ></b-form-textarea>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                Tehdyt tunnit {{format_start(selected.duration)}}
              </b-col>
            </b-row>
          </b-form>
        </b-container>
    </b-modal>

  </div>
</template>

<script>
import moment from 'moment';

export default {
  props:["selected"],
  data(){
    return {
      D_day: '-',
      info_text:""
    }
  },
  methods: {
     update_task(){
       if (this.D_day != "-"){
         this.selected.deadline = moment(this.D_day).format('DD/MM/YYYY');
         this.D_day = "-";
       }
       this.$bvModal.hide('modal-5');
     },
     format_start(time) {
       if (typeof time == 'undefined'){
         return "00:00"
       }
        return moment.utc(time).format('HH:mm');
      },
  },

}
</script>

<style lang="css" scoped>
.is-complete{
  background:  red !important;
  border: 0;
}
</style>
